module.exports = __webpack_public_path__ + "static/media/zameen-opal-v2.c21e9cd6.jpg";